const extendsFrom = (child, parent) => {
  let prototype = child.prototype;
  while (prototype) {
    if (prototype === parent.prototype)
      return true;
    prototype = Object.getPrototypeOf(prototype);
  }
  return false;
};
const getQueryParams = (paramObj) => {
  if (!paramObj) {
    return "";
  }
  const params = new URLSearchParams();
  Object.entries(paramObj).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((val) => {
        params.append(key, val);
      });
    } else if (typeof value !== "undefined" && value !== null) {
      params.append(key, value);
    }
  });
  return params.toString();
};
export {
  extendsFrom,
  getQueryParams
};
